module.exports = __webpack_public_path__ + "static/media/VIP_Room@3x.6dc64f5c.png";